<template>
    <form
        id="search-form"
        action="/search"
        method="GET"
        class="relative flex flex-shrink"
    >
        <input
            aria-label="Search"
            ref="searchInput"
            v-model="searchString"
            v-on:focus="searchInputFocus"
            v-on:keyup="searchInputType"
            v-click-away="searchDropdownClose"
            name="keywords"
            type="search"
            autocomplete="off"
            v-bind:placeholder="placeholder"
            class="bg-transparent block w-full rounded py-2.5 pl-6 pr-10 sm:text-sm border-2 border-xp-electron-green/30 focus:border-xp-electron-green/50 focus:ring-0 uppercase text-[13px] font-bold tracking-[2.5px] text-white"
        />
        <button
            ref="searchButton"
            type="submit"
            class="absolute inset-y-0 right-0 pr-4 flex items-center"
            aria-label="Search"
        >
            <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
            </svg>
        </button>
    </form>
</template>

<script>
import Hub from '../../events/hub'

export default {
    name: 'SearchBox',
    props: {
        keywords: {
            required: false,
            type: String,
        },
        placeholder: {
            required: false,
            type: String,
            default: 'Search',
        }
    },
    data: () => ({
        searchString: '',
    }),
    watch: {
        searchString: function (newSearch, oldSearch) {
            if (oldSearch && oldSearch.length > 0 && newSearch.length == 0) {
                Hub.$emit('search-dropdown-reset')
            }
        }
    },
    mounted() {
        this.searchString = this.keywords
    },
    methods: {
        searchDropdownClose() {
            Hub.$emit('search-dropdown-close')
        },
        searchInputFocus() {
            Hub.$emit('search-input-focus')
        },
        searchInputType($event) {
            Hub.$emit('search-input-type', $event.target.value)
        }
    }
}
</script>
